import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Accept all other props with `...rest`
const PrivateRoute = ({ children, ...rest }) => { 
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Use React.cloneElement to pass the extra props (`questUpdateCounter`) to the child
  return React.cloneElement(children, rest);
};

export default PrivateRoute;